import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from 'utils/axios';
import AxiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

export const getQuota = createAsyncThunk('GET QUOTA', async (data, thunkAPI) => {
  let sorting = data.sorting === 'ascend' ? 'asc' : 'desc';

  let query = `?page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&agency_name=${data.agencyName}`;

  //if (data?.agencyId) {
  //  query = `?agencyId=${data?.agencyId}&page=${data.page}&pageSize=${data.pageSize}&limit=${data.limit}&text=${data.text}&bookingStatus=${data.bookingStatus}&provider=${data.provider}&refundability=${data.refundability}&paymentGateway=${data.paymentGateway}&currency=${data.currency}&startDate=${data.startDate}&endDate=${data.endDate}&sorting=${data.sorting}&userType=${data.userType}&sortingField=${data.sortingField}&travelStartDate=${data.travelStartDate}&travelEndDate=${data.travelEndDate}&agencyName=${data.agencyName}&cogs=${data.cogs}&cogsPaidDate=${data.cogsPaidDate}&agencyCommissionPaid=${data.agencyCommissionPaid}&agencyCommissionPaidDate=${data.agencyCommissionPaidDate}&isNonLogin=${data.isNonLogin}`;
  //}
  const response = await AxiosAdmin.get(`${URL.QUOTA}${query}`, thunkAPI);
  return response.data;
});

export const getQuotaDetails = createAsyncThunk('GET QUOTA DETAILS', async (data, thunkAPI) => {
  const response = await AxiosAdmin.get(`${URL.QUOTA}/${data.agency_id}`, thunkAPI);
  let requestData = {
    agency_id: data.agency_id,
    update_limit_value: data.update_limit_value,
    threshold: response.data.data.data.threshold,
    current_value: response.data.data.data.current_value,
    currency: response.data.data.data.currency,
    limit_value: response.data.data.data.limit_value,
    status: response.data.data.data.status,
  };
  thunkAPI.dispatch(updateQuota(requestData));
  return response.data;
});

export const updateQuotaDetails = createAsyncThunk('UPDATE_QUOTA_DETAILS', async (data, thunkAPI) => {
  const response = await AxiosAdmin.get(`${URL.QUOTA}/${data.agency_id}`, thunkAPI);
  const requestData = {
    agency_id: data.agency_id,
    updated_limit_value: Number(data.update_limit_value) || 0,
    threshold: response.data.data.threshold,
    current_value: response.data.data.current_value,
    currency: response.data.data.currency,
    limit_value: response.data.data.limit_value,
    status: response.data.data.status || 'PENDING',
  };
  const response1 = await AxiosAdmin.put(`${URL.QUOTA}`, requestData, thunkAPI);
  return response1.data;
});

export const updateQuotaThersold = createAsyncThunk('UPDATE_QUOTA_THRESHOLD', async (data, thunkAPI) => {
  const response = await AxiosAdmin.get(`${URL.QUOTA}/${data.agency_id}`, thunkAPI);
  const requestData = {
    agency_id: data.agency_id,
    updated_limit_value: Number(data.update_limit_value) || 0,
    threshold: data.threshold,
    current_value: response.data.data.current_value,
    currency: response.data.data.currency,
    limit_value: response.data.data.limit_value,
    status: response.data.data.status || 'PENDING',
  };
  const response1 = await AxiosAdmin.put(`${URL.QUOTA}`, requestData, thunkAPI);
  return response1.data;
});

export const updateQuota = createAsyncThunk('UPDATE_QUOTA_BOOKING', async (data, thunkAPI) => {
  const response = await AxiosAdmin.put(`${URL.QUOTA}}`, data, thunkAPI);
  return response.data;
});

export const addQuota = createAsyncThunk('ADD_QUOTA', async (data, thunkAPI) => {
  const response = await AxiosAdmin.post(URL.QUOTA, data, thunkAPI);
  return response.data;
});

export const approveQuota = createAsyncThunk('APPROVE_QUOTA', async (data, thunkAPI) => {
  const response = await AxiosAdmin.put(`${URL.QUOTA}/approve`, data, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  quotaData: null,
  quotaDetails: null,
};

export const quotaSlice = createSlice({
  name: 'quota',
  initialState,
  reducers: {},
  extraReducers: {
    // get quota
    [getQuota.pending]: (state) => {
      state.isLoading = true;
      console.log('getQuota.pending');
      state.quotaData = null;
    },
    [getQuota.fulfilled]: (state, action) => {
      state.isLoading = false;
      console.log('getQuota.fulfilled');
      console.log('action.payload.data', action.payload);
      state.quotaData = action.payload.data;
    },
    [getQuota.rejected]: (state, action) => {
      state.isLoading = false;
      console.log('getQuota.rejected');
      state.quotaData = null;
      toast.error(action?.payload?.message);
    },

    // get quota Details
    [getQuotaDetails.pending]: (state) => {
      state.isLoading = true;
      state.quotaDetails = null;
    },
    [getQuotaDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.quotaDetails = action.payload.data;
    },
    [getQuotaDetails.rejected]: (state, action) => {
      state.isLoading = false;
      state.quotaDetails = null;
      toast.error(action?.payload?.message);
    },

    // add quota
    [addQuota.pending]: (state) => {
      state.isLoading = true;
    },
    [addQuota.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload?.message);
    },
    [addQuota.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error adding quota');
    },
    // update quota booking
    [updateQuota.pending]: (state) => {
      state.isLoading = true;
    },
    [updateQuota.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload?.message);
    },
    [updateQuota.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating agency quota');
    },

    [updateQuotaDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload?.message);
    },
    [updateQuotaDetails.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating quota details');
    },

    [updateQuotaThersold.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload?.message);
    },
    [updateQuotaThersold.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating threshold');
    },
  },
});

export default quotaSlice.reducer;
